/* eslint-disable import/no-anonymous-default-export */
import { useState } from "react";
//@ts-ignore
import { svgAsPngUri, svgAsDataUri } from 'codeful-save-svg-as-png'

export interface DrawSvgProps {
    onDraw?: (svgXml: string) => any
}

export default (props: DrawSvgProps) => {

    const setSvgXml = (svg: SVGSVGElement, svgXml: string) => {
        svg.innerHTML = svgXml;
    };

    const onSvgMouseDown = (evt:React.MouseEvent<SVGElement, MouseEvent>, svg:SVGSVGElement) => {
        if (evt.button != 2) return;
        //@ts-ignore
        if (evt.target.nodeName != "svg") {
            //@ts-ignore
            evt.target.remove();
            props.onDraw?.(svg.innerHTML);
        }
    }


    const drawRect = (svg: SVGSVGElement, evt: React.MouseEvent<SVGElement, MouseEvent>) => {
        if (evt.button != 0) return;

        const id = svg.childElementCount;
        const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        rect.id = `rect-${id}`;

        const startX = (evt.nativeEvent.offsetX / svg.clientWidth) * 100;
        const startY = (evt.nativeEvent.offsetY / svg.clientHeight) * 100;
        rect.setAttribute("x", `${startX}%`);
        rect.setAttribute("y", `${startY}%`);
        rect.setAttribute("width", "30%"); 
        rect.setAttribute("height", "30%"); 

        rect.style.filter = "blur(3px)";

        svg.appendChild(rect);
        props.onDraw?.(svg.innerHTML);

        const onDraw = (evt: MouseEvent) => {
            const endX = (evt.offsetX / svg.clientWidth) * 100;
            const endY = (evt.offsetY / svg.clientHeight) * 100;
            rect.setAttribute("width", `${endX - startX}%`);
            rect.setAttribute("height", `${endY - startY}%`);
            props.onDraw?.(svg.innerHTML);
        };

        const removeMoveEventListener = () => {
            svg.removeEventListener('mousemove', onDraw)
            svg.removeEventListener('mouseup', removeMoveEventListener);
        };

        svg.addEventListener('mouseup', removeMoveEventListener);

        svg.removeEventListener('mousemove', onDraw);
        svg.addEventListener('mousemove', onDraw);

    }


    return {
        drawRect,
        setSvgXml,
        onSvgMouseDown
    }

};